<template>
  <div
    class="relative w-100 vh-100 overflow-hidden bg-light"
    :class="{ 'background-leaves': development.brand === 'lh' }"
  >
    <div
      class="absolute w-100 vh-100 top-0 left-0 cover"
      style="filter: opacity(0.35);"
    />
    <transition
      @enter="animEnter"
      @leave="animLeave"
      mode="out-in"
    >
      <router-view
        :development="development"
        :house-style="houseStyle"
        :sales-advisor="development.sales_advisor"
        :plot="plot"
      />
    </transition>
    <div
      v-show="!$route.path.endsWith($route.params.plot)"
      class="fixed top-0 left-0 bottom-0 w-25"
    >
      <Sidebar
        :brand="development.brand"
        :navigation="nav"
        :title="'<strong>' + plot.HouseType + '</strong> | ' + plot.Name"
      />
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/property/Sidebar'
import transitions from '../transitions.js'

const find = require('lodash/find')

export default {
  name: 'Property',
  components: {
    Sidebar
  },
  data () {
    return {
      previous: 0
    }
  },
  computed: {
    activeTab () {
      return this.$store.state.sidebarTab
    },
    prevTab () {
      return this.$store.state.prevSidebarTab
    },
    development () {
      if (this.$store.state.content) {
        return this.$store.getters.getDevelopment('developments/' + this.$route.params.development)
      } else {
        return null
      }
    },
    plot () {
      if (this.development && this.$store.state.content) {
        const plots = this.$store.getters.getPlots(this.development.crm)
        return find(plots, ['Name', 'Plot ' + this.$route.params.plot])
      } else {
        return null
      }
    },
    purchaseOptions () {
      return this.$store.state.content.purchaseOptions
    },
    houseStyle () {
      if (this.development && this.plot && this.$store.state.content) {
        return find(this.development.styles, ['crm', this.plot.HouseTypeId])
      } else {
        return null
      }
    },
    nav () {
      const url = '/developments/' + this.$route.params.development + '/' + this.$route.params.plot
      const nav = []

      if (this.houseStyle.floorplans && this.houseStyle.floorplans.length > 1) {
        const children = []
        this.houseStyle.floorplans.forEach(element => {
          const child = {
            title: element.caption,
            route: null
          }
          children.push(child)
        })

        const floorplans = {
          title: 'Floorplans',
          route: url + '/floorplans',
          children: children
        }
        nav.push(floorplans)
      }

      if (this.development.specification && this.development.specification.length > 1) {
        const children = this.development.specification
        const specifications = {
          title: 'Specifications',
          route: url + '/specifications',
          children: children
        }
        nav.push(specifications)
      }

      if (this.plot && this.purchaseOptions !== undefined) {
        const children = this.purchaseOptions

        for (let i = children.length - 1; i > 0; i--) {
          const element = children[i]
          if (element.id === 's2co6qa5' && this.plot.statusCode !== 'Not yet released') {
            children.splice(i, 1)
          }
          if (element.id === 'czmyroeo' && this.plot.sellingType !== 'Shared Ownership') {
            children.splice(i, 1)
          }
        }

        const purchaseOptions = {
          title: 'Purchase Options',
          route: url + '/purchase-options',
          children: children
        }
        nav.push(purchaseOptions)
      }

      return nav
    }
  },
  methods: {
    animEnter (el, done) {
      if (this.activeTab < this.prevTab) {
        transitions.fadeInUp(el, done)
      } else {
        transitions.fadeInDown(el, done)
      }
    },
    animLeave (el, done) {
      if (this.activeTab < this.prevTab) {
        transitions.fadeOutDown(el, done)
      } else {
        transitions.fadeOutUp(el, done)
      }
    }
  }
}
</script>
